module.exports = __webpack_public_path__ + "static/media/nevada-cover-og.5d1d4eb0.jpg";